import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { RoleStatus } from "../../../../enums";

import { Api } from "../../../../services/api";
import { Role } from "../../../../services/api/types/Roles";
import { useAppSelector } from "../../../../store/hooks";
import { RoleForm } from "../RolesForm";
import { RoleFormHeader, RoleFormType } from "../RolesForm/rolesFormSchema";
import { ColumnContainer } from "../../Admin.styles";
import { Tabs } from "../Tabs";
import axios from "axios";
import { FormikHelpers } from "formik";

const Container = styled(ColumnContainer)`
  gap: 72px;
`;

export const AddRoleForm: React.FC<{}> = () => {
  const history = useHistory();
  const user = useAppSelector(state => state.auth.user);
  const [rolePermissions, setRolePermissions] = useState<any>([]);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await Api.roles.getRoleList(user.accountId);
      const admin = response.data.roles.find(
        (role: any) => role.name === "Admin"
      );

      if (admin) fetchRolePermissions(admin.id);
    } catch (e) {
      console.error("Fetch Roles Error:", e);
    }
  };

  const fetchRolePermissions = async (adminId: string) => {
    try {
      const response = await Api.roles.getAdminRoles(adminId);
      setRolePermissions(response.data.permissions);
    } catch (e) {
      console.error("Fetch Role Permissions Error:", e);
    }
  };

  const submitValues = (
    values: RoleFormType,
    { setErrors }: FormikHelpers<RoleFormType>
  ) => {
    const data: Role = {
      id: "",
      status:
        values.status === "Active" || !values.status
          ? RoleStatus.Active
          : RoleStatus.Inactive,
      name: values.name || "",
      description: values.description || "",
      permissions: rolePermissions,
      members: [],
    };
    Api.roles
      .createRole(data)
      .then(res => {
        const currentLocation = history.location;
        currentLocation.pathname =
          currentLocation.pathname.split("/").slice(0, -1).join("/") +
          `/${res.data.id}/edit`;
        history.push(currentLocation);
      })
      .catch((error: Error) => {
        if (
          axios.isAxiosError(error) &&
          error.response &&
          error.response.data.detail ===
            'duplicate key value violates unique constraint "roles_name_key"'
        ) {
          setErrors({ name: "Name already used" });
        } else {
          console.error("Create Office", error);
        }
      });
  };

  return (
    <Container>
      <RoleForm header={RoleFormHeader.add} submitValues={submitValues} />
      <Tabs
        rolePermissions={rolePermissions}
        setRolePermissions={setRolePermissions}
      />
    </Container>
  );
};
